const isFiniteNumber = (v) => typeof v === 'number' && Number.isFinite(v);

export function computeScaleBounds(allValues, hardLow, hardHigh) {
  if (!allValues.length) return { combinedMin: 0, combinedMax: 1 };

  const dataMin = Math.min(...allValues);
  const dataMax = Math.max(...allValues);

  const hasLow = isFiniteNumber(hardLow);
  const hasHigh = isFiniteNumber(hardHigh);

  if (!hasLow && !hasHigh) {
    return { combinedMin: dataMin, combinedMax: dataMax };
  }

  let lowBound = dataMin;
  let highBound = dataMax;

  const aboveHigh = hasHigh && dataMin > hardHigh;
  const belowLow = hasLow && dataMax < hardLow;

  if (aboveHigh) {
    // Data is above high limit — show high, hide low
    lowBound = Math.min(dataMin, hardHigh);
    highBound = dataMax;
  } else if (belowLow) {
    // Data is below low limit — show low, hide high
    lowBound = dataMin;
    highBound = Math.max(dataMax, hardLow);
  } else {
    // Data is between limits (or overlapping) — show both
    if (hasLow) lowBound = Math.min(dataMin, hardLow);
    if (hasHigh) highBound = Math.max(dataMax, hardHigh);
  }

  return { combinedMin: lowBound, combinedMax: highBound };
}
